/**
 * A aba aberta antes de um deploy pede um pedaço do app que não existe mais.
 *
 * Cada módulo (admin, management, marketplace) é um arquivo com hash no
 * nome, baixado só quando a pessoa entra nele. Um deploy troca todos os
 * hashes e o servidor passa a ter só os novos -- e a aba que ficou aberta
 * ainda conhece os antigos. Ao logar, ela pede `App-<hash antigo>.js` e o
 * import falha com "Failed to fetch dynamically imported module"
 * (visto em produção em 14/10/2026).
 *
 * O remédio é recarregar: o index.html não tem cache (Caddyfile), então a
 * página volta com os hashes do deploy atual. UMA vez -- se o arquivo
 * faltar mesmo depois de recarregar, outra recarga não resolveria e só
 * prenderia a pessoa num laço. Aí a tela de erro assume (LimiteErro).
 */

const CHAVE = 'copy:recarga-nova-versao';

/** Uma recarga recente o bastante para ainda ser "a mesma tentativa". */
const JANELA_MS = 15_000;

/** O erro é de um pedaço do app que não carregou? */
export function ehModuloAusente(erro: unknown): boolean {
  const msg = erro instanceof Error ? erro.message : String(erro ?? '');
  // Chrome, Firefox e Safari dizem a mesma coisa de jeitos diferentes.
  return /dynamically imported module|Importing a module script failed|Unable to preload CSS/i
    .test(msg);
}

/**
 * Recarrega a página para pegar a versão publicada, a não ser que isso
 * acabou de ser feito. Devolve se recarregou.
 */
export function recarregarParaNovaVersao(): boolean {
  try {
    const ultima = Number(sessionStorage.getItem(CHAVE) ?? 0);
    if (Date.now() - ultima < JANELA_MS) return false;
    sessionStorage.setItem(CHAVE, String(Date.now()));
  } catch {
    // Sem sessionStorage não há como evitar o laço: melhor não recarregar
    // sozinho e deixar o botão da tela de erro.
    return false;
  }
  window.location.reload();
  return true;
}
